"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var Avatar_1 = require("@cvent/carina/components/Avatar/Avatar");
var useTheme_1 = __importDefault(require("../hooks/useTheme"));
var getAvatarStyles_1 = __importDefault(require("../formulas/getAvatarStyles"));
function BlockAvatar(props) {
    var styles = (0, getAvatarStyles_1.default)((0, useTheme_1.default)());
    return ((0, jsx_runtime_1.jsx)(Avatar_1.Avatar, __assign({}, props, ((styles === null || styles === void 0 ? void 0 : styles.text) ? { textColorOverride: String(styles.text.color) } : {}), ((styles === null || styles === void 0 ? void 0 : styles.background) ? { backgroundColorOverride: String(styles.background.backgroundColor) } : {}))));
}
exports.default = BlockAvatar;
//# sourceMappingURL=BlockAvatar.js.map